class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));

      // 【追加】検索送信前に検索語を補正する
      this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  // 【追加】検索送信時の処理
  onFormSubmit() {
    const normalizedValue = this.normalizeSearchTerm(this.input.value);

    if (normalizedValue !== this.input.value) {
      this.input.value = normalizedValue;
    }
  }

  // 【追加】検索ワードの補正
  normalizeSearchTerm(value) {
    let normalized = value.trim();

    // 半角カナなどを全角に寄せる
    normalized = normalized.normalize('NFKC');

    // 商品カテゴリ系の表記ゆれだけ変換する
    const keywordMap = [
      ['すてっかー', 'ステッカー'],
      ['しーる', 'シール'],
      ['あくりる', 'アクリル'],
      ['きーほるだー', 'キーホルダー'],
      ['きーりんぐ', 'キーリング'],
      ['ちゃーむ', 'チャーム'],
      ['ばっじ', 'バッジ'],
      ['かんばっじ', '缶バッジ'],
      ['ぽーち', 'ポーチ'],
      ['とーと', 'トート'],
      ['ばっぐ', 'バッグ'],
      ['きゃらっくす', 'キャラックス'],
      ['ぬいぐるみ', 'ぬいぐるみ']
    ];

    keywordMap.forEach(([from, to]) => {
      normalized = normalized.split(from).join(to);
    });

    return normalized;
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);